import { Link } from 'react-router';
import { FC } from 'react';
import logoImg from '@assets/img/logo/logo_png.png';
import { Image } from '@inexture/core';
const Logo: FC<{ link?: string }> = ({ link = '/' }) => {
  return (
    <Link
      to={link}
      className="inline-flex items-center"
      data-testid="app-logo-link"
      aria-label="Go to home"
    >
      <Image maw={170} src={logoImg} bgsz="contain" alt="Solvere Logo" />
    </Link>
  );
};

export default Logo;
